module.exports = __webpack_public_path__ + "img/Kenzie-Dill.f7562a23.png";